import React, { Component } from "react";
import Video from "../../about-mba-course/components/Video";
import Features from "../../about-mba-course/components/Features";
// import featuresItems from "../../about-mba-course/data/features.json";
import featuresData from "../data/features";
import * as Scroll from "react-scroll";
import ReactHtmlParser from "react-html-parser";

export default class FeatureSection extends Component {
    state = {
        selectedFeatureIndex: 0
    };

    handleSelectFeature(selectedFeature) {
        this.setState({
            selectedFeatureIndex: selectedFeature.index
        });
    }

    render() {
        return (
            <Scroll.Element
                name="mba-features"
                className="mba-features-container"
                ref={this.containerRef}
            >
                <div className="content">
                    <h2 className="title">
                    تمایزات دوره ترکیبی MBA آکادمی درایت
                    </h2>
                    <div className="row">
                        <div className="col-xs-12">
                            <Features
                                items={[
                                    { title: "تمایزات دوره", index: 0 },
                                    { title: "اساتید برجسته", index: 1 },
                                    { title: "تجربیات صنعتی", index: 2 },
                                    { title: "Case Study", index: 3 },
                                    {
                                        title: "آموزش با رویکرد ترکیبی",
                                        index: 4
                                    }
                                ]}
                                onSelectFeature={this.handleSelectFeature.bind(
                                    this
                                )}
                                selectedFeatureIndex={
                                    this.state.selectedFeatureIndex
                                }
                            />
                        </div>
                    </div>
                    <FeatureDetails
                        featureIndex={this.state.selectedFeatureIndex}
                    />
                </div>
            </Scroll.Element>
        );
    }
}

function FeatureDetails({ featureIndex }) {
    // const data = featuresData[featureIndex];
    switch (featureIndex) {
        case 0:
            return <FeatureSection4 {...featuresData[4]} />;
        case 1:
            return <FeatureSection0 {...featuresData[0]} />;
        case 2:
            return <FeatureSection1 {...featuresData[1]} />;
        case 3:
            return <FeatureSection3 {...featuresData[2]} />;
        case 4:
            return <FeatureSection2 {...featuresData[3]} />;
        default:
            throw new Error("undefined featureIndex selected");
    }
}

function FeatureSection0(props) {
    const { title, listItem, video, icons } = props;
    return (
        <div className="row second-row">
            <div className="col-xs-12 col-sm-6 feature-slid__content">
                <h3 className="feature-slid__content__title">{title}</h3>
                <ul className="feature-slid__content__list">
                    {listItem.map(i => (
                        <li>{i}</li>
                    ))}
                </ul>
                <div className="icons-container">
                    {icons.map(item => {
                        return (
                            <div className="icon-wrapper">
                                <img src={item} />
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="col-xs-12 col-sm-6 feature-slid__video-container">
                <img
                    src="/images/video-frame.png"
                    className="feature-slid__video-frame"
                    alt="video feature frame"
                />
                <video className="feature-slid__video" controls>
                    <source src={video} type="video/mp4" />
                </video>
            </div>
        </div>
    );
}

function FeatureSection1(props) {
    const { title, listItem, description, video, icons } = props;
    return (
        <div className="row second-row">
            <div className="col-xs-12 col-sm-6 feature-slid__content">
                <h3 className="feature-slid__content__title">{title}</h3>
                <p className="feature-slid__content__text">{description}</p>
                <ul className="feature-slid__content__list">
                    {listItem.map(i => (
                        <li>{i}</li>
                    ))}
                </ul>
                <div className="icons-container">
                    {icons.map(item => {
                        return (
                            <div className="icon-wrapper">
                                <img src={item} />
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="col-xs-12 col-sm-6 feature-slid__video-container">
                <img
                    src="/images/video-frame.png"
                    className="feature-slid__video-frame"
                    alt="video feature frame"
                />
                <video className="feature-slid__video" controls>
                    <source src={video} type="video/mp4" />
                </video>
            </div>
        </div>
    );
}

function FeatureSection2(props) {
    const { title, listItem, video, statistics } = props;
    return (
        <div className="row second-row">
            <div className="col-xs-12 col-sm-6 feature-slid__content">
                <h3 className="feature-slid__content__title">{title}</h3>
                <ul className="feature-slid__content__list">
                    {listItem.map(i => (
                        <li>{i}</li>
                    ))}
                </ul>
                <div className="statistics-container">
                    {statistics.map(item => {
                        return (
                            <div className="statistic">
                                <img
                                    className="statistic__icon"
                                    src={item.icon}
                                />
                                <span className="statistic__percentage">
                                    {item.percentage}
                                </span>
                                <span className="statistic__percentage-symbol">
                                    %
                                </span>
                                <span className="statistic__label">
                                    {item.label}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
            {/*<div className="col-xs-12 col-sm-6 feature-slid__video-container">*/}
            {/*    <img*/}
            {/*        src="/images/video-frame.png"*/}
            {/*        className="feature-slid__video-frame"*/}
            {/*        alt="video feature frame"*/}
            {/*    />*/}
            {/*    <video className="feature-slid__video" controls>*/}
            {/*        <source src={video} type="video/mp4" />*/}
            {/*    </video>*/}
            {/*</div>*/}
        </div>
    );
}

function FeatureSection3(props) {
    const { title, listItem, video, icons } = props;
    return (
        <div className="row second-row">
            <div className="col-xs-12 col-sm-6 feature-slid__content">
                <h3 className="feature-slid__content__title">{title}</h3>
                <ul className="feature-slid__content__list">
                    {listItem.map(i => (
                        <li>{i}</li>
                    ))}
                </ul>
                <div className="icons-container">
                    {icons.map(item => {
                        return (
                            <div className="icon-wrapper">
                                <img src={item} />
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="col-xs-12 col-sm-6 feature-slid__video-container">
                <img
                    src="/images/video-frame.png"
                    className="feature-slid__video-frame"
                    alt="video feature frame"
                />
                <video className="feature-slid__video" controls>
                    <source src={video} type="video/mp4" />
                </video>
            </div>
        </div>
    );
}

function FeatureSection4({ cards }) {
    return (
        <div className="feature-final-cards">


            {cards.map((item, index) => (
                <div className="feature-final-card">
                    <div
                        className="ffc_header"
                        style={{ backgroundColor: item.color }}
                    >
                        <h4 className="ffc_title">{item.title}</h4>
                        <div className="ffc_icon-container">
                            <img
                                src={item.icon}
                                alt={item.title}
                                className="ffc_icon"
                            />
                        </div>
                    </div>
                    <div className="ffc_body">
                        <p className="ffc_text">{item.text}</p>
                        <span
                            className="ffc_label"
                            style={{ backgroundColor: item.color }}
                        >
                            {item.label}
                        </span>
                        <div className="ffc-gradiant-overlay"></div>
                    </div>
                    <div className="ffc_footer">
                        {item.icons && (
                            <div className="ffc_footer_icons">
                                {item.icons.map(i => (
                                    <div className="ffc_footer_icon-container">
                                        <img
                                            src={i}
                                            alt="icon"
                                            className="ffc_footer_icon"
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                        {item.statistics && (
                            <div className="ffc_footer_statistics">
                                {item.statistics.map(i => (
                                    <div className="ffc_footer_statistic">
                                        <div className="ffc_footer_statistic_text">
                                            <p>%{i.percentage}</p>
                                            <p>{i.label}</p>
                                        </div>
                                        <img
                                            src={i.icon}
                                            alt="icon"
                                            className="ffc_footer_statistic_icon"
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}
